<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 6H20C21.1046 6 22 6.89543 22 8V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V8C2 6.89543 2.89543 6 4 6Z"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 8.5H6.5M6.5 8.5H8M6.5 8.5V15.5M6.5 15.5H5M6.5 15.5H8"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
import {DEFAULT_BRAND_SECONDARY_COLOR} from '../constants';

export default {
  inject: ['getBrandSecondaryBackground'],
  computed: {
    stroke() {
      const stroke = this.getBrandSecondaryBackground();
      console.log('brand primary background: ', stroke);
      return stroke || DEFAULT_BRAND_SECONDARY_COLOR;
    },
  },
};
</script>
